/** Stable Firestore doc for website/app content (not tied to Auth UID). */
export const ADMIN_CONTENT_DOC_ID = "app_content";

const CONTENT_HINT_KEYS = [
  "about_us",
  "faq",
  "eula",
  "privacy_policy",
  "terms_and_conditions",
  "terms_conditions",
  "cta_content",
  "social_links",
  "bodyContent",
  "contact",
];

function looksLikeContentDoc(data) {
  if (!data || typeof data !== "object") return false;
  return CONTENT_HINT_KEYS.some((key) => data[key] != null);
}

/**
 * Prefer `admin/app_content`; fall back to first legacy content-bearing doc.
 * (Migration to app_content is performed by the admin dashboard.)
 */
export async function fetchAdminContentDoc(db, { getDoc, getDocs, collection, doc }) {
  const contentRef = doc(db, "admin", ADMIN_CONTENT_DOC_ID);
  const contentSnap = await getDoc(contentRef);
  if (contentSnap.exists()) {
    return { id: contentSnap.id, ...contentSnap.data() };
  }

  const querySnapshot = await getDocs(collection(db, "admin"));
  const legacy = querySnapshot.docs.find(
    (d) => d.id !== ADMIN_CONTENT_DOC_ID && looksLikeContentDoc(d.data())
  );
  if (!legacy) return null;
  return { id: legacy.id, ...legacy.data() };
}
